export enum ComplianceState {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
